import type { PriceTypeType } from '@/api/hooks/useTenantConfig'
import { ICellEditorParams } from 'ag-grid-community'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { PriceTypesSelect } from './PriceTypesSelect'

interface PriceTypesEditorProps extends ICellEditorParams {
  value: PriceTypeType[]
}

export const PriceTypesEditor = forwardRef<
  {
    getValue: () => PriceTypeType[]
    isCancelBeforeStart: () => boolean
    isCancelAfterEnd: () => boolean
  },
  PriceTypesEditorProps
>((props, ref) => {
  const { value: defaultValue } = props

  const cellWidth = props.column?.getActualWidth()
  const cellHeight = props.eGridCell?.offsetHeight

  const [value, setValue] = useState<PriceTypeType[]>(defaultValue ?? [])

  useImperativeHandle(ref, () => ({
    getValue: () => value,
    isCancelBeforeStart: () => false,
    isCancelAfterEnd: () => false,
  }))

  return (
    <PriceTypesSelect
      value={value}
      onChange={setValue}
      width={cellWidth}
      height={cellHeight}
      autoFocus
      defaultOpen
    />
  )
})
